<template>
  <div style="display: flex;height: 100%;">
    <div class="left">
      <img src="../../assets/phone.png" alt="">
      <el-carousel  class="demonstration" indicator-position="outside">
        <el-carousel-item v-for="(val,key) in swiper.data" v-bind:key="key">
          <img :src="val" >
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="right">
      <div style="height:520px;overflow: auto;">
        <vue-upload is-list is-more v-model="swiper.data" ></vue-upload>
      </div>
<!--      <el-button type="primary" class="w-150" @click="submit">确定保存</el-button>-->
    </div>
  </div>
</template>

<script>
import VueUpload from "@/components/upload/upload";
export default {
name: "swiper_edit",
  components:{VueUpload},
  // model:{prop:'swiper' ,event:'swiper_submit'},
  props:{
    swiper : {type : Object, default : function (){return {}}},
  },
  data(){
  return{

  }
  },
  methods:{
    submit:function (){
      this.$emit('swiper_submit',this.swiper);
    }
  }
}
</script>

<style scoped>
.left{
  width: 300px;
  background: #f6f8f9;
  padding: 2px;
  margin-right: 20px;
}
.left img{width: 100%;}
.right{flex:1;}
</style>